import React, { Fragment, useEffect, useState } from "react";
import LinksComponent from "../../../components/Tenant/LinksComponent/LinksComponent";
import { useNavigate } from "react-router-dom";
import DataTableComponent from "../../../components/Tenant/DataTableComponent/DataTableComponent";
import CustomExport from "../../../components/CustomExport/CustomExport";
import {
    useDeleteUserMappingParentOrChildMutation,
    useGetAllMappingDetailsCountMutation,
    useGetAllMappingDetailsMutation,
} from "../../../features/tenant/userMapping/userMappingApi";
import ModalComponent from "../../../components/Tenant/ModalComponent/ModalComponent";
import { Menu } from "@headlessui/react";
import { TiDeleteOutline } from "react-icons/ti";
import toast from "react-hot-toast";

const ModenikMapping = () => {

    const [limit, setLimit] = useState(10);
    const [offset, setOffset] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [paginationResetToggle, setPaginationResetToggle] = useState(false);

    const [allMappingData, setAllMappingData] = useState([]);
    const [allMappingDataCount, setAllMappingDataCount] = useState(0);

    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [mobileToDelete, setMobileToDelete] = useState("");
    const [selectedTab, setSelectedTab] = useState("parent");
    const [checkUserMappingCount, setCheckUserMappingCount] = useState(null)

    const initialRequest = {
        mapped_app_user_mobile: "",
        app_user_mobile: "",
        limit: 10,
        offset: 0,
        startDate: "",
        endDate: "",
    };
    const [request, setRequest] = useState(initialRequest);
    const clearFilters = () => {
        setRequest(initialRequest);
    };

    useEffect(() => {
        if (
            request.mapped_app_user_mobile === "" &&
            request.app_user_mobile === ""
        ) {
            fetchuserMappingFunction();
        }
    }, [request]);
    const handlePageChange = (pageNumber) => {
        const newOffset = (pageNumber - 1) * limit;
        setOffset(newOffset);
        setRequest((prevRequest) => ({ ...prevRequest, offset: newOffset }));
        setCurrentPage(pageNumber);
    };

    const handlePerRowsChange = (newPerPage, page) => {
        setRequest((prevRequest) => ({
          ...prevRequest,
          limit: newPerPage,
          offset: 0,
        }));
        setLimit(newPerPage);
    setOffset(0);
        setCurrentPage(1);
        setPaginationResetToggle((prev) => !prev);

    };

    const [
        userMapping,
        {
            data: userMappingData,
            error: userMappingError,
            isLoading: userMappingIsLoading,
        },
    ] = useGetAllMappingDetailsMutation();

    const [
        userMappingCount,
        {
            data: userMappingCountData,
            error: userMappingCountError,
            isLoading: userMappingCountIsLoading,
        },
    ] = useGetAllMappingDetailsCountMutation();


    const [
        deleteUserMappingByMobile,
        {
            data: deleteUserMappingByMobileData,
            error: deleteUserMappingByMobileError,
            isLoading: deleteUserMappingByMobileIsLoading,
        },
    ] = useDeleteUserMappingParentOrChildMutation();


    useEffect(() => {

        if (userMappingData?.body?.appUsersList) {
            setAllMappingData(userMappingData?.body?.appUsersList)
        }
    }, [userMappingData])

    useEffect(() => {
        if (userMappingCountData) {
            setAllMappingDataCount(userMappingCountData?.body?.total)
        }

    }, [userMappingCountData])

    const [
        userMappingCsv,
        { data: userMappingCsvData, error: userMappingCsvError, isLoading: userMappingCsvIsLoading },
    ] = useGetAllMappingDetailsMutation();

    useEffect(() => {

        fetchuserMappingFunction();
        fetchuserMappingCountFunction();

    }, [limit, offset, request]);


    const fetchuserMappingFunction = () => {
        userMapping({
            token: sessionStorage.getItem("access_token"),
            tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
            body: request,
        });
    };

    const fetchuserMappingCountFunction = () => {
        userMappingCount({
            token: sessionStorage.getItem("access_token"),
            tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
            body: request,
        });
    };

    const fetchuserMappingCsvFunction = () => {
        const modifiedRequest = {
            ...request,
            limit: null,
            offset: null,
        };
        userMappingCsv({
            token: sessionStorage.getItem("access_token"),
            tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
            body: modifiedRequest,
        });
    };

    const [csvData, setCsvData] = useState(null);
    useEffect(() => {
        if (userMappingCsvData && userMappingCsvData?.body?.appUsersList) {
            setCsvData(userMappingCsvData?.body?.appUsersList);
        }

        if (userMappingCsvError) {
            setCsvData(null);
        }
    }, [userMappingCsvData, userMappingCsvError]);

    const columns = [
        {
            name: "S.No",
            cell: (row, idx) => offset + Number(idx + 1),
            sortable: true,
        },
        {
            name: "Parent Name",
            cell: (row) => row.app_user_name,
            sortable: true,
        },
        {
            name: "Parent Mobile",
            cell: (row) => row.app_user_mobile,
            sortable: true,
        },
        {
            name: "Parent User Type",
            cell: (row) => row.user_type,
            sortable: true,
        },
        {
            name: "Child Name",
            cell: (row) => row.mapped_app_user_name,
            sortable: true,
        },
        {
            name: "Child Mobile",
            cell: (row) => row.mapped_app_user_mobile,
            sortable: true,
        },
        {
            name: "Child User Type",
            cell: (row) => row.mapped_user_type,
            sortable: true,
        },

        {
            name: "Mapping For",
            cell: (row) => row.mapped_for,
            sortable: true,
        },
        {
            name: "Created At",
            cell: (row) => new Date(row.created_at).toLocaleString(),
            sortable: true,
        },
    ];

    const primaryColor = JSON.parse(sessionStorage.getItem("vendorTheme")).theme
        .color_shades;

    const handleDeleteMapping = () => {
        if (!mobileToDelete) {
            alert("Please enter a valid mobile number.");
            return;
        }

        const confirmDelete = window.confirm(
            `Are you sure you want to delete mapping for ${mobileToDelete}?`
        );

        if (!confirmDelete) return;

        deleteUserMappingByMobile({
            token: sessionStorage.getItem("access_token"),
            tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
            body: {
                mobile: mobileToDelete,
                type: selectedTab,
            },
        })

        setShowDeleteModal(false);
        setMobileToDelete("");

    };


    useEffect(() => {
        if (deleteUserMappingByMobileData && deleteUserMappingByMobileData?.body) {
            console.log("deleteUserMappingByMobileData", deleteUserMappingByMobileData.body)
            toast.dismiss();
            toast.success(` ${deleteUserMappingByMobileData?.body?.count} Mappings Deleted Successfully`, { id: "deleteUserMappingByMobileData" })
            fetchuserMappingFunction();
            fetchuserMappingCountFunction();
        }

        if (deleteUserMappingByMobileError) {
            toast.dismiss();
            if (deleteUserMappingByMobileError.status == 404) {
                toast.error("No Records Found", { id: "deleteUserMappingByMobileError" })
            } else {
                toast.error("Something went wrong.", { id: "deleteUserMappingByMobileError" })
            }
            fetchuserMappingFunction();
            fetchuserMappingCountFunction();
        }

        if (deleteUserMappingByMobileIsLoading) {
            toast.loading("Please wait..", { id: "deleteUserMappingByMobileIsLoading" })
        }
    }, [deleteUserMappingByMobileData, deleteUserMappingByMobileError, deleteUserMappingByMobileIsLoading]);

    return (
        <>
            <div className="flex w-full bg-gray-200 h-full justify-center">
                <div className="w-full ">
                    <div className="border-b bg-white border-gray-300 pl-6 py-2 shadow-sm text-xl font-bold">
                        All Users Mapping
                        <LinksComponent />
                    </div>

                    <div className="p-3">
                        {/* {otpsCsvData && otpsCsvData?.body?.otp && (
              <ExportCSV
                data={otpsCsvData && otpsCsvData?.body?.otp}
                columnsToExport={[
                  "name",
                  "mobile",
                  "otp",
                  "otp_type",
                  "otp_created_at",
                ]}
              />
            )} */}

                        <div className="mb-2">
                            <CustomExport
                                fetchData={fetchuserMappingCsvFunction}
                                data={csvData}
                                defaultColumnExport={[
                                    "app_user_name",
                                    "app_user_mobile",
                                    "mapped_app_user_name",
                                    "mapped_app_user_mobile",
                                    "created_at",
                                ]}
                                filename="mapping"
                            />
                        </div>

                        <div className="border-b  border-gray-300 bg-gray-50 rounded-t-lg p-3">
                            <div className="flex  space-x-2 justify-end">
                                <div className="w-52 h-10">
                                    <div className="relative searchin">
                                        <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                                            Parent Mobile
                                        </label>
                                        <input
                                            type="search"
                                            id="default-search"
                                            className="w-full px-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                                            placeholder="Parent Mobile No..."
                                            required
                                            value={request.app_user_mobile}
                                            onChange={(e) => {
                                                const newValue = e.target.value;
                                                setRequest((prevState) => {
                                                    return { ...prevState, app_user_mobile: newValue };
                                                });
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="w-52 h-10">
                                    <div className="relative searchin">
                                        <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                                            Child Mobile
                                        </label>
                                        <input
                                            type="search"
                                            id="default-search"
                                            className="w-full px-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                                            placeholder="Child Mobile"
                                            required
                                            value={request.mapped_app_user_mobile}
                                            onChange={(e) => {
                                                const newValue = e.target.value;
                                                setRequest((prevState) => {
                                                    return {
                                                        ...prevState,
                                                        mapped_app_user_mobile: newValue,
                                                    };
                                                });
                                            }}
                                        />
                                    </div>
                                </div>

                                <div className="w-52 ">
                                    <div className="relative searchin">
                                        <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                                            From Date
                                        </label>
                                        <input
                                            type="date"
                                            id="default-search"
                                            className="w-full datepd text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500  inputp"
                                            placeholder="Start Date"
                                            value={request.startDate}
                                            onChange={(e) => {
                                                const newValue = e.target.value;
                                                setRequest((prevState) => {
                                                    return {
                                                        ...prevState,
                                                        startDate: newValue,
                                                    };
                                                });
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="w-52 ">
                                    <div className="relative searchin">
                                        <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                                            End Date
                                        </label>
                                        <input
                                            type="date"
                                            id="default-search"
                                            className="w-full datepd text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500  inputp"
                                            placeholder="End Date"
                                            value={request.endDate}
                                            onChange={(e) => {
                                                const newValue = e.target.value;
                                                setRequest((prevState) => {
                                                    return {
                                                        ...prevState,
                                                        endDate: newValue,
                                                    };
                                                });
                                            }}
                                        />
                                    </div>
                                </div>

                                <div className="flex flex-row  gap-2 h-10">
                                    <div className="relative searchin">
                                        <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                                            &nbsp;
                                        </label>
                                        <button
                                            className="py-2 btn btn-outline-primary clear-both float-right  pdbtn_all"
                                            onClick={() => {
                                                fetchuserMappingFunction();
                                                // fetchOtpsCsvFunction();
                                            }}
                                        >
                                            Search
                                        </button>
                                    </div>
                                    <div className="relative searchin">
                                        <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                                            &nbsp;
                                        </label>
                                        <button
                                            className="btn btn-outline-primary clear-both float-right pdbtn_all whitespace-nowrap"
                                            onClick={() => {
                                                clearFilters();
                                            }}
                                        >
                                            Clear Filter
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className=" p-3 w-full bg-white shadow rounded-lg">
                            <DataTableComponent
                                keyField={(row) => row.SNo}
                                columns={columns}
                                data={allMappingData}
                                loading={userMappingIsLoading}
                                totalRows={allMappingDataCount}
                                handlePerRowsChange={handlePerRowsChange}
                                handlePageChange={handlePageChange}
                                paginationDefaultPage={currentPage}
                                paginationResetDefaultPage={paginationResetToggle}
                                striped
                                highlightOnHover
                                pointerOnHover
                                pagination
                            ></DataTableComponent>
                            {true && (
                                <div
                                    className="fixed bottom-0 right-16 w-16 h-16 mr-10 mb-2 cursor-pointer"
                                    id="box_btn"
                                >
                                    <div className="text-right">
                                        <Menu className="relative inline-block text-left">
                                            <div>
                                                <Menu.Button
                                                    onClick={() => setShowDeleteModal(true)}
                                                    className="inline-flex justify-cente w-12 h-12 rounded-full text-sm font-medium bg-red-500 text-white hover:bg-opacity-80 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 "
                                                >
                                                    <TiDeleteOutline className="w-full h-full p-1.5" />
                                                </Menu.Button>
                                            </div>
                                        </Menu>
                                    </div>
                                </div>
                            )}
                        </div>
                        {showDeleteModal && (
                            <ModalComponent
                                size={"md"}
                                show={showDeleteModal}
                                setShow={setShowDeleteModal}
                            >
                                <div className="bg-white p-6 rounded-lg shadow-lg">
                                    <h2 className="text-lg font-bold mb-4">Delete Mapping</h2>

                                    {/* Tab Selection */}
                                    <div className="flex border-b mb-4">
                                        <button
                                            onClick={() => setSelectedTab("parent")}
                                            className={`px-4 py-2 text-sm font-medium ${selectedTab === "parent"
                                                ? "border-b-2 border-blue-600 text-blue-600"
                                                : "text-gray-500"
                                                }`}
                                        >
                                            Parent
                                        </button>
                                        <button
                                            onClick={() => setSelectedTab("child")}
                                            className={`px-4 py-2 text-sm font-medium ${selectedTab === "child"
                                                ? "border-b-2 border-blue-600 text-blue-600"
                                                : "text-gray-500"
                                                }`}
                                        >
                                            Child
                                        </button>
                                    </div>

                                    <p className="mb-2 text-sm text-gray-600">
                                        Enter {selectedTab === "parent" ? "Parent" : "Child"} Mobile Number:
                                    </p>
                                    <input
                                        type="text"
                                        className="w-full border border-gray-300 rounded-md px-3 py-2 mb-4 focus:outline-none"
                                        placeholder={`Enter ${selectedTab === "parent" ? "Parent" : "Child"} Mobile Number`}
                                        value={mobileToDelete}
                                        maxLength={10}
                                        onChange={(e) => setMobileToDelete(e.target.value)}
                                    />
                                    <div className="flex justify-end gap-2">
                                        <button
                                            onClick={() => setShowDeleteModal(false)}
                                            className="px-4 py-2 text-sm text-gray-600 border border-gray-300 rounded hover:bg-gray-100"
                                        >
                                            Cancel
                                        </button>
                                        <button
                                            onClick={handleDeleteMapping}
                                            className="px-4 py-2 text-sm text-white bg-red-600 rounded hover:bg-red-700"
                                        >
                                            Delete
                                        </button>
                                    </div>
                                </div>

                            </ModalComponent>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default ModenikMapping;
